import { render, staticRenderFns } from "./SettingsRolesView.vue?vue&type=template&id=167efbab&scoped=true&lang=pug"
import script from "./SettingsRolesView.vue?vue&type=script&lang=ts"
export * from "./SettingsRolesView.vue?vue&type=script&lang=ts"
import style0 from "./SettingsRolesView.vue?vue&type=style&index=0&id=167efbab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167efbab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VSpacer})
